import { Label } from './ui/label';

// Field label: a lowercase/snake name in the muted tone.
export default function FieldLabel({ children, htmlFor, className = '' }) {
  return (
    <Label htmlFor={htmlFor} className={`text-muted-foreground ${className}`}>
      {children}
    </Label>
  );
}
